// extracted by mini-css-extract-plugin
module.exports = {"root":"checkbox_root__z87H7","checkIcon":"checkbox_checkIcon__597FE"};